<template>
    <v-menu
        :model-value="showDetails"
        :scrim="false"
        origin="auto"
        location="top center"
        offset="16"
        scroll-strategy="close"
        v-bind="$attrs"
        :close-on-content-click="false"
    >
        <template #activator="{ props }">
            <a
                v-bind="props"
                href="javascript:void(0);"
            >
                <slot name="default"></slot>

            </a>
        </template>
        <template #default>
            <v-card
                rounded="lg"
                class="pa-2 elevation-8"
                width="fit-content"
                title="Customer Service"
            >
                <v-card-text class="text-body-1">
                    Contact Customer Service by the following methods:
                </v-card-text>
                <v-list
                    class="text-body-1"
                    density="comfortable"
                >
                    <v-list-item
                        :tel="brandData.mainContactPhoneNumber"
                    >
                        <v-list-item-title
                            class="font-weight-medium"
                        >
                            Phone
                        </v-list-item-title>
                        {{ brandData.mainContactPhoneNumberFormatted }}
                    </v-list-item>
                    <v-list-item
                        :href="`mailto:${brandData.mainContactEmailAddress}`"
                    >
                        <v-list-item-title
                            class="font-weight-medium"
                        >
                            Email
                        </v-list-item-title>
                        {{ brandData.mainContactEmailAddress }}
                    </v-list-item>
                    <v-list-item
                        title=""
                        class="font-weight-medium"
                        :to="{ path: '/support/contact', query: { to: 'info' } }"
                    >
                        Web Form
                    </v-list-item>
                </v-list>
            </v-card>
        </template>
    </v-menu>
</template>

<script lang="ts" setup>
    const $config = useRuntimeConfig();
    const brandData = $config.public.brand;
    const showDetails = ref(false);
</script>

<style lang="scss"></style>
